import { ApiError } from '../api/client';

type Translate = (key: string) => string;

/** Backend error_key → i18n key under epTrading.errors.* */
const EP_ERROR_KEY_MAP: Record<string, string> = {
  'ep.buyer_no_usdt_wallet': 'epTrading.errors.buyerNoUsdtWallet',
  'ep.seller_no_usdt_wallet': 'epTrading.errors.sellerNoUsdtWallet',
  bad_request: 'epTrading.errors.badRequest',
};

/** Fallback when API still returns English msg without error_key (older builds). */
const EP_ERROR_MSG_MAP: Array<{ match: RegExp; key: string }> = [
  {
    match: /buyer has no bound USDT wallet/i,
    key: 'epTrading.errors.buyerNoUsdtWallet',
  },
  {
    match: /seller has no bound USDT wallet/i,
    key: 'epTrading.errors.sellerNoUsdtWallet',
  },
  {
    match: /Please use your bound BEP20 wallet/i,
    key: 'epTrading.errors.useBoundWallet',
  },
  {
    match: /Wallet connect is not configured/i,
    key: 'epTrading.errors.walletNotConfigured',
  },
  {
    match: /Please switch to BSC network/i,
    key: 'epTrading.errors.switchToBsc',
  },
  {
    match: /Invalid USDT pay configuration/i,
    key: 'epTrading.errors.invalidPayConfig',
  },
  {
    match: /Insufficient USDT/i,
    key: 'epTrading.errors.insufficientUsdt',
  },
];

export function localizeEpApiError(
  err: unknown,
  t: Translate,
  fallbackKey = 'epTrading.usdtPayFailed',
): string {
  if (err instanceof ApiError && err.errorKey) {
    const i18nKey = EP_ERROR_KEY_MAP[err.errorKey];
    if (i18nKey) return t(i18nKey);
  }

  const raw =
    err instanceof ApiError
      ? err.message
      : err instanceof Error
        ? err.message
        : typeof err === 'string'
          ? err
          : '';

  if (raw) {
    for (const { match, key } of EP_ERROR_MSG_MAP) {
      if (match.test(raw)) return t(key);
    }
    // Already localized Chinese from client-side throws
    if (/[\u4e00-\u9fff]/.test(raw)) return raw;
    return raw;
  }

  return t(fallbackKey);
}
